import React, { useEffect, useState } from "react";
import "./Medalha.css";
import Medalhas from "../modais/Medalhas.js";

import Medalha_romance_1 from "../imagem/Medalha_romance_1.svg";
import Medalha_romance_1_bloq from "../imagem/Medalha_romance_1_bloq.svg";
import Medalha_romance_2 from "../imagem/Medalha_romance_2.svg";
import Medalha_romance_3 from "../imagem/Medalha_romance_3.svg";

import Medalha_terror_1 from "../imagem/Medalha_terror_1.svg";
import Medalha_terror_1_bloq from "../imagem/Medalha_terror_1_bloq.svg";
import Medalha_terror_2 from "../imagem/Medalha_terror_2.svg";
import Medalha_terror_3 from "../imagem/Medalha_terror_3.svg";

import Medalha_fabula_1 from "../imagem/Medalha_fabula_1.svg";
import Medalha_fabula_1_bloq from "../imagem/Medalha_fabula_1_bloq.svg";
import Medalha_fabula_2 from "../imagem/Medalha_fabula_2.svg";
import Medalha_fabula_3 from "../imagem/Medalha_fabula_3.svg";

import Medalha_fantasia_1 from "../imagem/Medalha_fantasia_1.svg";
import Medalha_fantasia_1_bloq from "../imagem/Medalha_fantasia_1_bloq.svg";
import Medalha_fantasia_2 from "../imagem/Medalha_fantasia_2.svg";
import Medalha_fantasia_3 from "../imagem/Medalha_fantasia_3.svg";

import Medalha_misterio_1 from "../imagem/Medalha_misterio_1.svg";
import Medalha_misterio_1_bloq from "../imagem/Medalha_misterio_1_bloq.svg";
import Medalha_misterio_2 from "../imagem/Medalha_misterio_2.svg";
import Medalha_misterio_3 from "../imagem/Medalha_misterio_3.svg";

import Medalha_suspense_1 from "../imagem/Medalha_suspense_1.svg";
import Medalha_suspense_1_bloq from "../imagem/Medalha_suspense_1_bloq.svg";
import Medalha_suspense_2 from "../imagem/Medalha_suspense_2.svg";
import Medalha_suspense_3 from "../imagem/Medalha_suspense_3.svg";

export default function Medalha({ medalhas = [] }) {
  const [openModal, setOpenModal] = useState(false);
  const [medalhaSelecionada, setMedalhaSelecionada] = useState(null);
  const [novos, setNovos] = useState({});

  const imagens = {
    Romance: {
      niveis: [Medalha_romance_1, Medalha_romance_2, Medalha_romance_3],
      bloqueada: Medalha_romance_1_bloq,
    },
    Terror: {
      niveis: [Medalha_terror_1, Medalha_terror_2, Medalha_terror_3],
      bloqueada: Medalha_terror_1_bloq,
    },
    Fábula: {
      niveis: [Medalha_fabula_1, Medalha_fabula_2, Medalha_fabula_3],
      bloqueada: Medalha_fabula_1_bloq,
    },
    Fantasia: {
      niveis: [Medalha_fantasia_1, Medalha_fantasia_2, Medalha_fantasia_3],
      bloqueada: Medalha_fantasia_1_bloq,
    },
    Mistério: {
      niveis: [Medalha_misterio_1, Medalha_misterio_2, Medalha_misterio_3],
      bloqueada: Medalha_misterio_1_bloq,
    },
    Suspense: {
      niveis: [Medalha_suspense_1, Medalha_suspense_2, Medalha_suspense_3],
      bloqueada: Medalha_suspense_1_bloq,
    },
  };

  // Detectar medalhas novas desbloqueadas
  useEffect(() => {
    const detectados = {};

    medalhas.forEach((m) => {
      const viu = localStorage.getItem(`medalhaViu_${m.genero}`);

      if (m.nivel > 0 && !viu) {
        detectados[m.genero] = true;
        localStorage.setItem(`medalhaViu_${m.genero}`, "true");
      }
    });

    setNovos((prev) => {
      const mudou =
        Object.keys(detectados).length !== Object.keys(prev).length;
       return mudou ? detectados : prev;
    });
  }, [medalhas]);
 
  const abrirModal = (medalha) => {
    setMedalhaSelecionada(medalha);
    setOpenModal(true);
  };

  const fecharModal = () => setOpenModal(false);

  const pegarImagem = (genero, nivel) => {
    const pack = imagens[genero];
    if (!pack) return "";

    switch (true) {
      case (nivel === 0):
        return pack.bloqueada;
      case (nivel === 1):
        return pack.niveis[0];
      case (nivel === 2):
        return pack.niveis[1];
      case (nivel === 3):
        return pack.niveis[2];
      case (nivel > 3):
        return pack.niveis[2];
    }
  };

  return (
    <div className="medalhas-container">
      <div className="medalhas-grid">
        {medalhas.map((m) => {
          const imagem = pegarImagem(m.genero, m.nivel);

          return (
            <div
              key={m.idMedalha}
              className={`medalha-item ${m.nivel === 0 ? "bloqueada" : ""}`}
              onClick={() => abrirModal(m)}
            >
              <img src={imagem} alt={m.genero} />

              {novos[m.genero] && <span className="novo-banner">Novo!</span>}

              <p>{m.genero}</p>
            </div>
          );
        })}
      </div>

      {medalhaSelecionada && (
        <Medalhas
          open={openModal}
          onClose={fecharModal}
          genero={medalhaSelecionada.genero}
          nivel={medalhaSelecionada.nivel}
          pontuacao={medalhaSelecionada.pontosNoNivel}
          pontuacaoMax={250}
        />
      )}
    </div>
  );
}
